import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { signInOutSelector } from 'src/pages/Account/Profile/Signin/store/selectors';
import { signInOutSlice } from 'src/pages/Account/Profile/Signin/store/slice';

import { UiButton } from '../../UI/Button';

export const SignOutButtonComponent: React.FC = () => {
  const dispatch = useDispatch();

  const {
    signOut: { loading },
  } = useSelector(signInOutSelector);

  const signOutClick = useCallback((): void => {
    dispatch(signInOutSlice.actions.signOutStart());
  }, [dispatch]);

  const { t } = useTranslation();

  return (
    <UiButton onClick={signOutClick} className="sign-out" loading={loading} tag="a" dataTest="signOutButton">
      {t('header.account.signOut')}
    </UiButton>
  );
};
